import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ScheduleModel} from '../../../../projects/api/src/schedule/schedule.model';
import {ScheduleTemplateModel} from '../../../../projects/api/src/template/template.model';
import {RuleModel} from '../../../../projects/api/src/rule/rule.model';
import {ApiList} from '../../API/api-list.enum';
import {SemRestRequestService} from '../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {TranslateService} from '@ngx-translate/core';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'app-ruleon-panel-edit',
  templateUrl: './ruleon-panel-edit.component.html',
  styleUrls: ['./ruleon-panel-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RuleonPanelEditComponent implements OnInit, OnChanges {
  @Input() referenceData: { rule: RuleModel[]; schedule: ScheduleModel[]; scheduletemplate: ScheduleTemplateModel[] };
  @Input() editableData;
  @Input() saveComplete;
  @Input() create;
  @Input() stateParams;

  public templateData: ScheduleTemplateModel;
  public rule: RuleModel;
  public schedule: ScheduleModel;
  buttonLabels = {save: 'SAVE'};

  constructor(private request: SemRestRequestService,
              private translate: TranslateService,
              private snackBar: MatSnackBar
  ) {

  }

  ngOnInit() {
    if (this.stateParams.typicalconfig) {
      this.referenceData.rule = this.referenceData.rule.filter(
        _rule => _rule.typicalconfig.id === this.stateParams.typicalconfig);
    }
    if (!this.editableData || !this.editableData.template) {
      this.templateData = {
        mode: 'UNION',
        name: '',
        comment: '',
        planningareas: []
      };
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.stateParams.schedule);
      this.editableData = {locked: false};
    } else {
      this.templateData = this.referenceData.scheduletemplate.find(_sti => _sti.id === this.editableData.template?.id);
      this.rule = this.referenceData.rule.find(_rpi => _rpi.id === this.editableData.rule?.id);
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.editableData.schedule?.id);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.stateParams.typicalconfig) {
      this.referenceData.rule = this.referenceData.rule.filter(
        _rule => _rule.typicalconfig.id === this.stateParams.typicalconfig
      );
    }
    if (!this.editableData) {
      this.templateData = {
        mode: 'UNION',
        name: '',
        comment: '',
        planningareas: []
      };
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.stateParams.schedule);
      this.editableData = {locked: false};
      this.buttonLabels.save = 'CREATE';
    } else {
      this.templateData = this.referenceData.scheduletemplate.find(_sti => _sti.id === this.editableData.template.id);
      this.rule = this.referenceData.rule.find(_rpi => _rpi.id === this.editableData.rule.id);
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.editableData.schedule.id);
      this.buttonLabels.save = 'SAVE';
    }
  }

  /**
   * Сохраняет или создает данные Paramon
   */
  public save() {
    const triggerWhenSaveDone = () => {
      this.saveComplete();
      this.snackBar.open(
        this.translate.instant('Item successfully saved'),
        null,
        {duration: 5000, panelClass: ['c-mat-snack-bar_container__bottom-right', 'c-mat-snack-bar__success']});
    };

    this.request
      .baseUrlAppend(ApiList.Db, ApiList.Ruleon);

    if (this.editableData && this.editableData.id) {
      this.request.updateById(this.editableData.id, {
        locked: this.editableData.locked,
        rule: this.rule,
        schedule: this.schedule,
        template: this.templateData
      }).subscribe(triggerWhenSaveDone.bind(this));
    } else {
      this.request.postFormData({
        locked: this.editableData.locked,
        rule: this.rule,
        schedule: this.schedule,
        template: this.templateData
      }).subscribe(triggerWhenSaveDone.bind(this));
    }
  }

  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if ( val.isEmpty ) {
      this[fieldName] = null;
    }
  }

  getRuleTitle(): string {
    try {
      return this.editableData.rule.rulename;
    } catch(e) {
      return 'Create';
    }
  }
}
